class utils {
    constructor() {
        this.loading = true
        this.processing = false
        this.loaded = false
        this.onload = false
        this.cookies = true
        this.notificationBox = []
        this.hoverOnNotifications = true

        this.filters = {
            validateEmail: (mail) => {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return true
                }
                return false
            },

            password: (password) => {
                const has_minimum_lenth = password.length > 8;
                const has_number = /\d/.test(password);
                const has_lowercsae = /[a-z]/.test(password);
                const has_uppercase = /[A-Z]/.test(password);
                const has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);

                return {
                    has_minimum_lenth: has_minimum_lenth,
                    has_number: has_number,
                    has_lowercsae: has_lowercsae,
                    has_uppercase: has_uppercase,
                    has_special: has_special,
                };
            },

            name: (name) => {
                const has_minimum_lenth = name.length > 3;
                const only_letters = /^[a-z@.-]+$/.test(name);
                let is_mail = true

                if (name.includes('@')) {
                    is_mail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(name)
                }

                return {
                    has_minimum_lenth: has_minimum_lenth,
                    only_letters: only_letters,
                    is_mail: is_mail
                };
            },

            fullname: (name) => {
                const has_minimum_lenth = name.length > 3;
                const only_letters = /^[a-z ]+$/.test(name);

                return {
                    has_minimum_lenth: has_minimum_lenth,
                    only_letters: only_letters
                };
            },

            stringLimit(val, limit) {
                if (val.length < limit) return val
                return val.substring(0, limit) + '...'
            }


        }

        this.use = {

            browserused: () => {
                let browser = "Unknown";
                // Get the user-agent string
                let userAgentString = navigator.userAgent;

                // Detect Chrome
                let chromeAgent = userAgentString.indexOf("Chrome") > -1;

                // Detect Internet Explorer
                let IExplorerAgent =
                    userAgentString.indexOf("MSIE") > -1 ||
                    userAgentString.indexOf("rv:") > -1;

                // Detect Firefox
                let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

                // Detect Safari
                let safariAgent = userAgentString.indexOf("Safari") > -1;

                // Discard Safari since it also matches Chrome
                if (chromeAgent && safariAgent) safariAgent = false;

                // Detect Opera
                let operaAgent = userAgentString.indexOf("OP") > -1;

                // Discard Chrome since it also matches Opera
                if (chromeAgent && operaAgent) chromeAgent = false;

                if (safariAgent) {
                    browser = "safari";
                } else if (chromeAgent) {
                    browser = "chrome";
                } else if (IExplorerAgent) {
                    browser = "IExplorer";
                } else if (operaAgent) {
                    browser = "opera";
                } else if (firefoxAgent) {
                    browser = "firefox";
                }

                return browser;
            },

            osused: () => {
                let os = "Unknown";
                if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
                    os = "Windows 10";
                if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
                    os = "Windows 8.1";
                if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
                    os = "Windows 8";
                if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
                    os = "Windows 7";
                if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
                    os = "Windows Vista";
                if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
                    os = "Windows XP";
                if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
                    os = "Windows 2000";
                if (window.navigator.userAgent.indexOf("Mac") != -1) os = "Mac/iOS";
                if (window.navigator.userAgent.indexOf("X11") != -1) os = "UNIX";
                if (window.navigator.userAgent.indexOf("Linux") != -1) os = "Linux";

                return os;
            },

            deviceused: () => {
                let devive = "Unknown";
                var isMobile = window.orientation > -1;

                if (isMobile && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    devive = "smartphone";
                } else {
                    devive = "desktop";
                }

                return devive;
            },

            getLanguage: () => {
                let language = "Unknown";


                if (window.navigator.language) {
                    language = window.navigator.language;
                }

                return language;
            },
        }
    }

    switTypeInput(val) {
        if (document.querySelector("#password").type == "text") {
            document.querySelector("#password").type = "password";
        } else {
            document.querySelector("#password").type = "text";
        }

        if (document.querySelector("#replaypassword")) {
            if (document.querySelector("#replaypassword").type == "text") {
                document.querySelector("#replaypassword").type = "password";
            } else {
                document.querySelector("#replaypassword").type = "text";
            }
        }
    }


    // HOW TO SENDING MESSAGE FOR POPUP 
    // $store.state.utils.setNewNotifications({
    //     type: 'info, warning, hint, success',
    //     title: 'Hinweis! (option)',
    //     message: 'your text',
    //     url: 'link (option)' ,
    //   }, 1500)
    removeNotifications(interval) {
        setTimeout(() => {
            if (this.hoverOnNotifications) {
                this.notificationBox.shift()
            } else {
                this.removeNotifications(interval)
            }
        }, interval);
    }

    setNewNotifications(val, interval = 0) {
        this.notificationBox.push(val)
        if (interval > 100) {
            this.removeNotifications(interval)
        }
    }

}
export default utils